import { useEffect, useState } from 'react';
import styles from '../onboarding/OnboardingPage.module.scss';
import Spinner from '../ui/spinners/Spinner';
import { confirmMFA } from '../../services/userService';
import { useParams } from 'react-router-dom';
import { getText } from '../../i18n';

const VerifyMFA = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(true);
    const { token } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseStatus = await confirmMFA(token);
                if (responseStatus === 200) setHasError(false);
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div className={styles.container}>
            <div className="">
                {isLoading ? (
                    <Spinner width={50} />
                ) : (
                    <>
                        <div className={`${styles.authContainer} card`}>
                            <div className="text-center">
                                {hasError ? (
                                    <>
                                        <h2>{getText('msg_7f2f6a15cf8d')}</h2>
                                        <p>
                                            {getText('msg_29fc45ca7eb6')}
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <h2>{getText('msg_7ce01f638146')}</h2>
                                        <p>
                                            {getText('msg_14a0bbe302ce')}
                                        </p>
                                    </>
                                )}
                                <div className="form-group d-grid gap-2 col-10 mx-auto text-center pt-3">
                                    <p>
                                        <a href={`/login`} className="pl-2">
                                            {getText('msg_82b38f24c725')}
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default VerifyMFA;
